import { render, staticRenderFns } from "./DialogPageSettings.vue?vue&type=template&id=4a4e89de"
import script from "./DialogPageSettings.vue?vue&type=script&lang=js"
export * from "./DialogPageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports